import { vgaPalette } from './palette.js';

export class PaletteUI {
  constructor(onColorSelect) {
    this.palette = document.getElementById('palette');
    this.onColorSelect = onColorSelect;
    this.activeColorIndex = 15; // Default to white
  }

  render() {
    this.palette.innerHTML = '';
    vgaPalette.forEach((color, index) => {
      const swatch = document.createElement('div');
      swatch.className = 'palette-color';
      swatch.style.backgroundColor = color;
      swatch.tabIndex = 0;
      swatch.setAttribute('aria-label', `Color ${color}`);
      swatch.setAttribute('title', `Color ${color}`);
      swatch.dataset.colorIndex = index;
      swatch.addEventListener('click', () => {
        this.onColorSelect(index);
      });
      this.palette.appendChild(swatch);
    });
    this.updateSelection();
  }

  setActiveColor(colorIndex) {
    this.activeColorIndex = colorIndex;
    this.updateSelection();
  }

  updateSelection() {
    // Remove selection from all colors
    this.palette.querySelectorAll('.palette-color').forEach(swatch => {
      swatch.classList.remove('selected');
    });
    
    // Add selection to active color
    const activeSwatch = this.palette.querySelector(`[data-color-index="${this.activeColorIndex}"]`);
    if (activeSwatch) {
      activeSwatch.classList.add('selected');
    }
  }
} 